/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export const MIN_REVIEW_LENGTH = 300;

export const REVIEW_COMPOSER_MIN_HEIGHT = 440;

export const MAX_RATING = 5;
